export default 'mdi mdi-tow-truck';
